import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../components/buttons/customButton';
import { useSendLinkedInConnect } from '../../../apiHooks/mutations/connectLinkedIn/sendLinkedInConnect';
import useGetLinkedIn from '../../../apiHooks/queries/getLinkedIn/getLinkedIn';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';
import SecondaryButton from '../../../components/buttons/secondaryButton';
import { Colors } from '../../../constants/constants';
import TextInput from '../../../components/inputs/textInput';
import LoadingSpinner from '../../../components/loadingSpinner/loadingSpinner';
import { facebookIntegrationUrl, tiktokIntegrationUrl } from '../../../constants/integrationConstants';

const TiktokPanel = () => {
  const { t } = useTranslation();
  const organizationSettings = useOrganizationSettingsStore((state) => state.organizationSettings);
  const { mutate: sendInvite } = useSendLinkedInConnect();
  const { refetch } = useGetLinkedIn('LINKED_IN');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');

    if (code) {
      sendInvite(code, {
        onSettled: () => {
          setLoading(false);
          const newUrl = `${window.location.origin}${window.location.pathname}`;
          window.history.replaceState({}, document.title, newUrl);
        },
      });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (organizationSettings.tiktokToken) {
    return (
      <div className="flex justify-between gap-5 rounded-xl border p-4">
        <div className="flex gap-5">
          <CustomButton
            loading
            type="button"
            onClick={() => {
              window.location.href = tiktokIntegrationUrl;
            }}
          >
            {t('disconnect')}
          </CustomButton>
        </div>
        <div className="flex items-center justify-center gap-3 text-xs font-medium text-primary">
          <div>
            {t('accountStatus')}
          </div>
          <SecondaryButton
            style={{
              border: `1px solid ${Colors.green}`,
              color: Colors.green,
              height: '40px',
              fontSize: 14,
            }}
          >
            {t('active')}
          </SecondaryButton>
        </div>
      </div>
    );
  }

  if (!organizationSettings.tiktokToken) {
    return (
      <div className="flex justify-between gap-5 rounded-xl border p-4">
        <div className="flex flex-col gap-2 text-primary">
          <span className="text-sm font-semibold">{t('connectToTiktok')}</span>
          <p className="text-sm font-normal">{t('hereYouLinkTiktok')}</p>
        </div>
        <CustomButton
          loading
          type="button"
          onClick={() => {
            window.location.href = tiktokIntegrationUrl;
          }}
        >
          {t('connectToTiktok')}
        </CustomButton>
      </div>
    );
  }

  return (
    <div className="flex h-full items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};

export default TiktokPanel;
